import './PixelProps.css';

// Pixel Art Donkey
export const PixelDonkey = ({ walking = false, direction = 'right' }: { walking?: boolean; direction?: 'left' | 'right' }) => {
  return (
    <div className={`pixel-donkey ${walking ? 'walking' : ''} ${direction}`}>
      {/* Ears */}
      <div className="donkey-ear donkey-ear-left"></div>
      <div className="donkey-ear donkey-ear-right"></div>

      {/* Head */}
      <div className="donkey-head">
        <div className="donkey-eye"></div>
        <div className="donkey-nostril"></div>
        <div className="donkey-muzzle"></div>
      </div>

      {/* Mane */}
      <div className="donkey-mane"></div>

      {/* Body */}
      <div className="donkey-body"></div>

      {/* Legs */}
      <div className="donkey-leg donkey-leg-fl"></div>
      <div className="donkey-leg donkey-leg-fr"></div>
      <div className="donkey-leg donkey-leg-bl"></div>
      <div className="donkey-leg donkey-leg-br"></div>

      {/* Tail */}
      <div className="donkey-tail"></div>
    </div>
  );
};

// Pixel Art Sign (for sign flipping)
export const PixelSign = ({ text = "HIRE ME!", spinning = false }: { text?: string; spinning?: boolean }) => {
  return (
    <div className={`pixel-sign ${spinning ? 'spinning' : ''}`}>
      <div className="sign-board">
        <span className="sign-text">{text}</span>
      </div>
      <div className="sign-handle"></div>
    </div>
  );
};

// Pixel Art Coffee Cup (matches PixelCoffee style)
export const PixelCoffeeCup = ({ steaming = true }: { steaming?: boolean }) => {
  return (
    <div className="pixel-coffee-cup">
      {steaming && (
        <div className="coffee-steam">
          <div className="steam steam-1"></div>
          <div className="steam steam-2"></div>
          <div className="steam steam-3"></div>
        </div>
      )}
      <div className="coffee-liquid"></div>
      <div className="coffee-cup-body">
        <div className="coffee-cup-pattern"></div>
      </div>
      <div className="coffee-handle"></div>
    </div>
  );
};

// Pixel Art Laptop
export const PixelLaptop = ({ open = true }: { open?: boolean }) => {
  return (
    <div className={`pixel-laptop ${open ? 'open' : 'closed'}`}>
      <div className="laptop-screen">
        <div className="laptop-screen-content">
          <div className="screen-line"></div>
          <div className="screen-line"></div>
          <div className="screen-line short"></div>
        </div>
      </div>
      <div className="laptop-base">
        <div className="laptop-keyboard"></div>
        <div className="laptop-trackpad"></div>
      </div>
    </div>
  );
};

export type PropType = 'donkey' | 'sign' | 'coffee' | 'laptop';

interface PixelPropProps {
  type: PropType;
  active?: boolean;
  direction?: 'left' | 'right';
}

const PixelProp = ({ type, active = false, direction = 'right' }: PixelPropProps) => {
  switch (type) {
    case 'donkey':
      return <PixelDonkey walking={active} direction={direction} />;
    case 'sign':
      return <PixelSign spinning={active} />;
    case 'coffee':
      return <PixelCoffeeCup steaming={active} />;
    case 'laptop':
      return <PixelLaptop open={active} />;
    default:
      return null;
  }
};

export default PixelProp;
